export default __webpack_public_path__ + "static/media/logotipo_white.6e0d5609.svg";